/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminListingCheck,
    AdminListingCheckFromJSON,
    AdminListingCheckFromJSONTyped,
    AdminListingCheckToJSON,
} from './AdminListingCheck';
import {
    AdminListingReason,
    AdminListingReasonFromJSON,
    AdminListingReasonFromJSONTyped,
    AdminListingReasonToJSON,
} from './AdminListingReason';
import {
    AdminListingSeverity,
    AdminListingSeverityFromJSON,
    AdminListingSeverityFromJSONTyped,
    AdminListingSeverityToJSON,
} from './AdminListingSeverity';
import {
    AdminMarketReferenceSource,
    AdminMarketReferenceSourceFromJSON,
    AdminMarketReferenceSourceFromJSONTyped,
    AdminMarketReferenceSourceToJSON,
} from './AdminMarketReferenceSource';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminListingAnalytics
 */
export interface AdminListingAnalytics {
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    buyerShipping: number;
    /**
     * 
     * @type {string}
     * @memberof AdminListingAnalytics
     */
    computedAt: string;
    /**
     * Confidence of the market reference, 0..1.
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    confidence?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    daysListed: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    daysSincePriceChange: number;
    /**
     * FloorPrice is the lowest price that keeps the minimum net.
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    floorPrice: number;
    /**
     * Gap is our price minus the suggested price.
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    gap?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    gapRatio?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminListingAnalytics
     */
    link: string;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    listingId: number;
    /**
     * MarketChangePct is the market move since our last price change (-0.1 = 10% down).
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    marketChangePct?: number;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminListingAnalytics
     */
    marketplace: AdminMarketplaceType;
    /**
     * MarketplaceCheck is the latest check of the listing on its marketplace
     * (eBay only for now); null when it was never checked.
     * @type {AdminListingCheck}
     * @memberof AdminListingAnalytics
     */
    marketplaceCheck?: AdminListingCheck;
    /**
     * OurNet is what we get at our price after fees and our shipping label.
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    ourNet: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    ourPrice: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    ourTotal: number;
    /**
     * 
     * @type {Array<AdminListingReason>}
     * @memberof AdminListingAnalytics
     */
    reasons: Array<AdminListingReason>;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    referenceAtPriceChange?: number;
    /**
     * ReferencePrice is the market buyer total; null when there is no market data.
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    referencePrice?: number;
    /**
     * 
     * @type {AdminMarketReferenceSource}
     * @memberof AdminListingAnalytics
     */
    referenceSource?: AdminMarketReferenceSource;
    /**
     * 
     * @type {AdminListingSeverity}
     * @memberof AdminListingAnalytics
     */
    severity: AdminListingSeverity;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    soldCount: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    suggestedNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    suggestedPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminListingAnalytics
     */
    targetPrice?: number;
}



export function AdminListingAnalyticsFromJSON(json: any): AdminListingAnalytics {
    return AdminListingAnalyticsFromJSONTyped(json, false);
}

export function AdminListingAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminListingAnalytics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'buyerShipping': json['buyerShipping'],
        'computedAt': json['computedAt'],
        'confidence': !exists(json, 'confidence') ? undefined : json['confidence'],
        'daysListed': json['daysListed'],
        'daysSincePriceChange': json['daysSincePriceChange'],
        'floorPrice': json['floorPrice'],
        'gap': !exists(json, 'gap') ? undefined : json['gap'],
        'gapRatio': !exists(json, 'gapRatio') ? undefined : json['gapRatio'],
        'link': json['link'],
        'listingId': json['listingId'],
        'marketChangePct': !exists(json, 'marketChangePct') ? undefined : json['marketChangePct'],
        'marketplace': AdminMarketplaceTypeFromJSON(json['marketplace']),
        'marketplaceCheck': !exists(json, 'marketplaceCheck') ? undefined : AdminListingCheckFromJSON(json['marketplaceCheck']),
        'ourNet': json['ourNet'],
        'ourPrice': json['ourPrice'],
        'ourTotal': json['ourTotal'],
        'reasons': ((json['reasons'] as Array<any>).map(AdminListingReasonFromJSON)),
        'referenceAtPriceChange': !exists(json, 'referenceAtPriceChange') ? undefined : json['referenceAtPriceChange'],
        'referencePrice': !exists(json, 'referencePrice') ? undefined : json['referencePrice'],
        'referenceSource': !exists(json, 'referenceSource') ? undefined : AdminMarketReferenceSourceFromJSON(json['referenceSource']),
        'severity': AdminListingSeverityFromJSON(json['severity']),
        'soldCount': json['soldCount'],
        'suggestedNet': !exists(json, 'suggestedNet') ? undefined : json['suggestedNet'],
        'suggestedPrice': !exists(json, 'suggestedPrice') ? undefined : json['suggestedPrice'],
        'targetPrice': !exists(json, 'targetPrice') ? undefined : json['targetPrice'],
    };
}

export function AdminListingAnalyticsToJSON(value?: AdminListingAnalytics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'buyerShipping': value.buyerShipping,
        'computedAt': value.computedAt,
        'confidence': value.confidence,
        'daysListed': value.daysListed,
        'daysSincePriceChange': value.daysSincePriceChange,
        'floorPrice': value.floorPrice,
        'gap': value.gap,
        'gapRatio': value.gapRatio,
        'link': value.link,
        'listingId': value.listingId,
        'marketChangePct': value.marketChangePct,
        'marketplace': AdminMarketplaceTypeToJSON(value.marketplace),
        'marketplaceCheck': AdminListingCheckToJSON(value.marketplaceCheck),
        'ourNet': value.ourNet,
        'ourPrice': value.ourPrice,
        'ourTotal': value.ourTotal,
        'reasons': ((value.reasons as Array<any>).map(AdminListingReasonToJSON)),
        'referenceAtPriceChange': value.referenceAtPriceChange,
        'referencePrice': value.referencePrice,
        'referenceSource': AdminMarketReferenceSourceToJSON(value.referenceSource),
        'severity': AdminListingSeverityToJSON(value.severity),
        'soldCount': value.soldCount,
        'suggestedNet': value.suggestedNet,
        'suggestedPrice': value.suggestedPrice,
        'targetPrice': value.targetPrice,
    };
}

